import React from "react";
import {
  Box,
  Pagination,
  Typography,
  Select,
  MenuItem,
} from "@mui/material";

interface Props {
  page: number;
  rowsPerPage: number;
  totalItems: number;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (rows: number) => void;
}

const AdvancedPagination: React.FC<Props> = ({
  page,
  rowsPerPage,
  totalItems,
  onPageChange,
  onRowsPerPageChange,
}) => {
  const totalPages = Math.ceil(totalItems / rowsPerPage);

  const start = (page - 1) * rowsPerPage + 1;
  const end = Math.min(page * rowsPerPage, totalItems);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: 2,
        py: 1.5,
        borderTop: "1px solid #eee",
        background: "#fff",
      }}
    >
      {/* Left Info */}
      <Typography fontSize={14}>
        Showing Results <b>{start}</b> - <b>{end}</b> of <b>{totalItems}</b>
      </Typography>

      {/* Center Pagination */}
      <Pagination
        count={totalPages}
        page={page}
        onChange={(e, value) => onPageChange(value)}
        shape="rounded"
        siblingCount={1}
        boundaryCount={1}
      />

      {/* Right Only Items Per Page */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography fontSize={14}>Items per Page:</Typography>

        <Select
          size="small"
          value={rowsPerPage}
          onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
          sx={{
            fontSize: 14,
            height: 32,
            borderRadius: 2,
          }}
        >
          {[5, 10, 20, 50].map((num) => (
            <MenuItem key={num} value={num}>
              {num}
            </MenuItem>
          ))}
        </Select>
      </Box>
    </Box>
  );
};

export default AdvancedPagination;
